// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__pGrEr","input":"index_input__ZkPe7","suffix":"index_suffix___sB7U"};